
<template>
  <div id="container">
    <div class="item-box-content box-content-title">
      <div class="title-font-style">
        <span>供应商余额统计</span>
      </div>
    </div>
    <div>
      <el-form class="search-style" :model="queryParams">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="供应商编号：" label-width='85px'>
              <el-input v-model='valList[0].value'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="供应商名称：" label-width='85px'>
              <el-input v-model='valList[1].value'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="text-align:left;">
            <el-col :span="18">
            <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button @click="onReset">重置</el-button>
            </el-col>
            <el-col :span='6' style='text-align:right;padding:0px;'>
            <el-button @click="exportOut">导出</el-button>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
      <div class="box-table" :style="{height:tableHeight+'px'}">
        <el-table
           :summary-method="getSummaries"
           show-summary
          :max-height="tableHeight"
          border
          ref="tableRef"
          tooltip-effect="dark"
          :data="list"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column label="供应商编号" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class='line-limit-length'>{{ scope.row.cusCode || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="供应商名称" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class='line-limit-length'>{{ scope.row.cusName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="账户余额" >
            <template slot-scope="scope">
              <div>{{scope.row.accountBalance |priceFilterNum}}</div>
            </template>
          </el-table-column>
          <el-table-column label="可提现余额" >
            <template slot-scope="scope">
              <div >{{scope.row.withdrawCash |priceFilterNum}}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="详情">
            <template slot-scope="scope">
              <el-button type='text' @click='checkSlider(scope.row)'>查看</el-button>
            </template>
          </el-table-column> -->

        </el-table>
      </div>
      <div class="pagination" >
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
  <!-- -----查看详情------- -->
  <customer-slider ref='customerSliderRefs'></customer-slider>
  </div>
</template>
<script>

import pagination from '@/components/pagination'
import { querySupplierAccountList, exportSupplierAccountList } from '@/api/supplier/supplierManage'
import { downLoadFileBlob } from '@/util/tool'
import customerSlider from '../slider/customerSlider'

export default {
  components: {
    pagination,
    'customer-slider': customerSlider
  },

  data () {
    return {
      valList: [
        { value: '', column: 'cusCode' },
        { value: '', column: 'cusName' }
      ],
      searchList: [],
      tableHeight: window.innerHeight - 385,
      queryParams: {},
      list: [],
      loadingTable: false, // 列表loading
      pageSize: 30, //
      currentPage: 1, // 页码
      total: 0 // 列表总数
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getSummaries (param) { // 合计
      const sums = []
      param.columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
        } else if (index === 2) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +(prov.accountBalance)
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 3) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +(prov.withdrawCash)
          }, 0)
          sums[index] = total.toFixed(2)
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    // 列表
    getList () {
      this.loadingTable = true
      const params = {
        criteriaVoList: [...this.searchList],
        queryPageName: ''
      }
      querySupplierAccountList(this.currentPage, this.pageSize, params).then(res => {
        if (res.data.code === 200) {
          this.list = res.data.obj.records
          this.total = res.data.obj.total
          this.loadingTable = false
        }
      })
    },
    // 查询
    onSearch () {
      this.searchList = []
      if (this.valList.some((ele) => ele.value)) {
        this.pageSize = 30
        this.currentPage = 1
        this.valList.forEach((ele) => {
          if (ele.value) {
            ele.collection = true
            this.searchList.push(ele)
          }
        })
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },

    // 重置
    onReset () {
      this.pageSize = 30
      this.currentPage = 1
      this.searchList = []
      this.valList.forEach((ele) => {
        delete ele.value
      })
      this.getList()
    },
    // 查看
    checkSlider(row) {
      this.$refs.customerSliderRefs.onInitialize(2, row)
    },
    // 导出
    exportOut () {
      exportSupplierAccountList()
        .then((res) => {
          downLoadFileBlob(this, res)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }

}
</script>
<style lang="scss" scoped>

</style>
